import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { useDarkMode } from './hooks/useDarkMode';
import WhatsAppButton from './components/feature/WhatsAppButton';
import ExitIntentPopup from './components/feature/ExitIntentPopup';
import ScrollToTop from './components/feature/ScrollToTop';
import BackToTopButton from './components/feature/BackToTopButton';

function App() {
  useDarkMode();

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AppRoutes />
      <WhatsAppButton />
      <BackToTopButton />
      <ExitIntentPopup />
    </BrowserRouter>
  );
}

export default App;
